import { createSelector } from 'reselect'
import {
  getList,
  getFilter,
  getSort,
  getPagination,
  getQuery,
  getCreatedList
} from 'react-redux/selectors/playlist'
import {
  getFilter as getGlobalFilter
} from 'react-redux/selectors/app'
import {
  getDragAndDrop
} from 'react-redux/selectors/drag-and-drop'

export default createSelector(
  [ getList, getFilter, getSort, getPagination, getGlobalFilter, getQuery, getCreatedList, getDragAndDrop],
  (list, filter, sort, pagination, globalFilter, query, createdList, dragAndDrop) => {
    return Object.assign(
      {},
      list,
      createdList,
      sort,
      pagination,
      filter,
      query,
      {
        globalFilter: globalFilter.filter
      },
      { dragAndDrop },
    )
  }
)



// WEBPACK FOOTER //
// ./src/app/component/playlist/selector.js